import { Card as CardType, WyrTypes } from "../types";
interface WyrCard extends CardType {
  activity: WyrTypes | "other";
}

export const WYR_CARDS: WyrCard[] = [
  {
    genre: "wyr",
    description:
      "Would you rather watch your parents have sex or have them watch you have sex?",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    genre: "wyr",
    description:
      "Would you rather never drink again or only drink one type of alcohol forever?",
    penaltyCost: 2,
    activity: "other",
    pub: true,
  },
  {
    genre: "wyr",
    description:
      "Would you rather be caught naked in public or caught having sex by your parents?",
    penaltyCost: 3,
    activity: "other",
    pub: true,
  },
  {
    description: "Eat nothing but beans | Eat nothing but asparagus",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Live completely without sexual feelings | Have the sex drive of a 15 year old boy",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "Kill 20 strangers | Kill 1 person you know",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "Have tongues for fingers | Have a finger as a tongue",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Know when someone is lying | Able to lie without ever being caught",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "Stay outside forever | Stay inside forever",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "Live in a theme park forever | Live in a zoo forever",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "See the future | Change the past",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "Invisibility | Flight",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "12 inch peen | 1 inch peen",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Never see another person again | Handcuffed to another person forever",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "MMF | FFM",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description:
      "always be slightly cold | always slightly having the urge to pee",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "Penis sized nipples | nipple sized penis",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description:
      "Have sex with your mum and noone will know | Not have sex with your mum, but everyone will think you did",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "give a rimjob | receive a rimjob",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    description: "drink a pint of cum | drink a pint of piss",
    penaltyCost: 1,
    genre: "wyr",
    activity: "other",
    pub: true,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	give up pizza forever or chocolate forever? Explain why.",
    penaltyCost: 1,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather have a one-night stand with your boss or your best friend's ex?",
    penaltyCost: 2,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	watch the person 5 to the left wank, or have the person 2 to the right watch you wank?",
    penaltyCost: 2,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	kiss your friend's mum or your friend's sibling?",
    penaltyCost: 2,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	never have sex again or only have bad sex for life?",
    penaltyCost: 4,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	send a nude to your ex or to a random stranger?",
    penaltyCost: 3,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	accidentally send a nude to your parents or your boss?",
    penaltyCost: 3,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	hook up with your high school crush or your worst ex?",
    penaltyCost: 2,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	watch the person 4 to the right hook up or have the person 3 to the left watch you hook up?",
    penaltyCost: 4,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	never have foreplay again or never have aftercare again?",
    penaltyCost: 3,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	give up oral sex or penetrative sex for the rest of your life?",
    penaltyCost: 4,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	only do it in public or only do it in the dark?",
    penaltyCost: 3,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	confess your deepest fantasy or act it out in front of the group?",
    penaltyCost: 5,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	always have to dirty talk during sex or never say a word during sex?",
    penaltyCost: 3,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	date someone who's super kinky or the someone who's very vanilla?",
    penaltyCost: 2,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description: "Would You Rather	never kiss again or never cuddle again?",
    penaltyCost: 3,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	cheat on your partner or be cheated on and never find out?",
    penaltyCost: 4,
  },
  {
    genre: "wyr",
    activity: "other",
    pub: true,
    description:
      "Would You Rather	only ever be able to use toys or never be able to use toys again?",
    penaltyCost: 3,
  },
];
